import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useUserMsp } from "../hooks/useUserMsp";
import { useFeatureFlag } from "../hooks/useFeatureFlag";
import { isCustomWorkflowsNavVisible } from "../utils/customWorkflowsAccess";
import { isTheoPilotEnabled } from "../utils/theoPilotAccess";

/**
 * Custom Workflows routes: LaunchDarkly `customworkflows` on, plus optional env allowlist
 * (same rules as the Sidebar). `theo-pilot` closes the page even when that gate is open.
 * Otherwise redirect to Chat Assistant.
 */
const CustomWorkflowsRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const flags = useFeatureFlag();
  const { user } = useAuth0();
  const { userMspInfo } = useUserMsp();

  const flagRecord = flags as Record<string, unknown>;
  if (
    !isTheoPilotEnabled(flagRecord) &&
    isCustomWorkflowsNavVisible(flagRecord, {
      email: user?.email,
      mspId: userMspInfo?.msp_id,
    })
  ) {
    return <>{children}</>;
  }
  return <Navigate to="/chat-assistant" replace />;
};

export default CustomWorkflowsRoute;
